import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Support access, which lives at `/settings/grants`.
 *
 * The spec lists `admin/grants` among the administration routes and M4-03 had already built the page
 * at `/settings/grants`, beside the banner that links to it. Two routes rendering the same screen
 * would be two screens to keep in step, and a second copy of a page about who may see this tenant's
 * data is exactly the wrong page to have two of. So the address the spec names exists and sends the
 * person to the one page: the administration sidebar links straight there, and a bookmark or a typed
 * `/admin/grants` still arrives.
 */
export const Route = createFileRoute('/admin/grants')({
  beforeLoad() {
    throw redirect({ to: '/settings/grants' });
  },
});
